import React from 'react';
import Modal from '@material-ui/core/Modal';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { rhythm } from 'Themes/typography';
import Paper from '@material-ui/core/Paper';
import Section from '../Section';
import AddPhoto from '../AddPhoto';
import SpecificationItem from '../SpecificationItem';
import NoteAndUrl from '../NoteAndUrl';
import SpecificationSheets from '../SpecificationSheets';
import IesFile from '../IesFile';
import { Url } from '../Url';
import compact from 'lodash.compact';
import pick from 'lodash.pick';
import values from 'lodash.values';
import Quotation from '../Quotation';
import SupplyPhoto from '../SupplyPhoto';
import Logo from './components/Logo';
import axios from 'Axios';
import { API_ROOT } from 'Api/Routes';
import { SupplyNote } from '../../../../../Demand/screens/SingleSlip/components/SupplyNote';

const TitleLeft = styled.h1`
  font-size: 1rem;
  display: inline-block;
  float: left;
`;

const TitleRight = styled.h1`
  font-size: 1rem;
  display: inline-block;
  float: right;
  margin-bottom: ${rhythm(1)};
`;

const JobNo = styled.h1`
  font-size: 1rem;
`;

const Clear = styled.div`
  clear: both;
`;

const CompanyInfo = styled(Grid)`
  @media (max-width: 959px) {
    border-top: 1px solid #999a9a;
    border-left: unset;
  }
  align-items: center;
  border-top: unset;
  border-left: 1px solid #999a9a;
  //   display: flex;
`;

const SpecLeft = styled(Grid)` 
 @media (max-width: 959px) {
    
  border-right: none;
  }
  border-right: 1px solid #999a9a;
  margin 5px 0 !important;
`;

const FooterSheetRight = styled(Grid)`
  border-left: 1px solid #999a9a;
  @media (max-width: 959px) {
    border-top: 1px solid #999a9a;
    border-left: unset;
  }
`;

const SpecificationSheetFooter = styled(Grid)`
  margin-top: ${rhythm(0.3)} !important;
  margin-bottom: ${rhythm(0.3)} !important;
`;

const ArupInfo = styled(Grid)`
  align-items: center;
  //   display: flex;
`;

const MainContainer = styled.div`
  padding: 2rem;
  padding-top: 0.8rem;
`;

const InfoTitle = styled.h4`
  padding-bottom: 0.375rem;
`;
const InfoLeft = styled.span`
  font: 400 11px system-ui;
  font-size: 0.875rem;
`;
const InfoRight = styled.span`
  color: #62727b;
  font: 400 11px system-ui;
  font-size: 0.875rem;
`;
const InfoLeftLogo = styled.span`
  font: 400 11px system-ui;
  font-size: 0.875rem;
  margin-right: 5px;
`;
const LogoWrapper = styled.span`
  display: flex;
  align-items: center;
`;

const H1NoMargin = styled.h1`
  color: hsla(0, 0%, 0%, 0.8) !important;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  color: inherit;
  font-family: 'Helvetica', 'Arial', sans-serif;
  font-weight: bold;
  text-rendering: optimizeLegibility;
  line-height: 1.1;
  margin: 0;
`;

const DownloadButton = styled(Button)`
  :hover:not([class*='MuiPickersCalendarHeader']) {
    background-color: white !important;
  }
`;

function getModalStyle() {
  const topBottom = 5;
  const leftRight = 15;
  return {
    top: `${topBottom}%`,
    left: `${leftRight}%`,
    right: `${leftRight}%`,
    bottom: `${topBottom}%`,
    // transform: `translate(-${top / 2}%, -${left / 2}%)`,
  };
}

const styles = theme => ({
  paper: {
    position: 'absolute',
    // width: theme.spacing.unit * 50,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    // padding: theme.spacing.unit * 4,
    outline: 'none',
  },
  modalStyle1: {
    position: 'absolute',
    top: '10%',
    left: '10%',
    overflowX: 'hidden',
    overflowY: 'auto !important',
    height: '90%',
    display: 'block',
  },
});

class InternalSlipsInfoModal extends React.Component {
  state = {
    // addDialog: false,
  };
  //   openAddDialog = () => {
  //     this.setState({ addDialog: true });
  //   };
  //   closeAddDialog = () => {
  //     this.setState({ addDialog: false });
  //   };

  separateNotes = note => {
    let finalNotes = '';
    if (note) {
      const split = note.split('_$_');
      split.forEach((el, index) => {
        finalNotes += '<b style="color:black;">' + '•' + '</b> ' + el + '<br/>';
      });
    }
    return { __html: finalNotes };
  };

  getSpecificationSheets(data) {
    if (!data) return [];
    return compact(values(pick(data, ['file1', 'file2', 'file3'])));
  }
  getSupplyPhotos(data) {
    if (!data) return [];
    return compact(values(pick(data, ['image1Id', 'image2Id', 'image3Id'])));
  }
  downloadSpecSheet = () => {
    axios({
      url: 'zip/spec_sheet/' + this.props.internalSlip.id,
      method: 'GET',
      responseType: 'blob', // important
    }).then(
      response => {
        if (response.data) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'SpecificationSheet.zip'); //or any other extension
          document.body.appendChild(link);
          link.click();
        }
      },
      error => {
        console.error(error);
      }
    );
  };

  renderCriteriaSide = side => {
    const { specificationSheetValue } = this.props.internalSlip;
    const values = Object.entries(specificationSheetValue);
    let criteriaToRender;
    if (side === 'left') {
      criteriaToRender = values.slice(0, values.length / 2 + 1);
    } else if (side === 'right') {
      criteriaToRender = values.slice(values.length / 2 + 1, values.length);
    }

    return criteriaToRender.map((item, i) => {
      let result = item[0].replace(/([A-Z])/g, ' $1');
      let words = result.charAt(0).toUpperCase() + result.slice(1);
      return (
        <SpecificationItem
          name={`specificationSheetValue.${item[0]}`}
          key={item[0]}
          title={words}
          value={specificationSheetValue[item[0]]}
        />
      );
    });
  };

  render() {
    const { classes } = this.props;
    if (!this.props.internalSlip) return null;
    // set manufaturer name because we dont have this field in db for specsheet
    this.props.internalSlip.specificationSheetValue.manufacturer = this.props.internalSlip.companyDetailsResponse.companyName;

    return (
      <React.Fragment>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.props.openModal}
          onClose={this.props.handleCloseModal}
        >
          <div
            style={getModalStyle()}
            className={this.props.classes.modalStyle1 + ' ' + classes.paper}
          >
            <MainContainer>
              <Section>
                <div>
                  <TitleLeft>
                    Project Title:
                    {this.props.internalSlip.projectDetails &&
                      ' ' + this.props.internalSlip.projectDetails.name}
                  </TitleLeft>
                  <TitleRight>Luminaire Specification Sheet</TitleRight>
                </div>

                <Clear> </Clear>
                <JobNo>
                  Job No.:
                  {this.props.internalSlip.projectDetails &&
                    ' ' +
                      this.props.internalSlip.projectDetails
                        .uniqueProjectNumber}
                </JobNo>
                <div className="spacer-2" />
                <Grid container spacing={8}>
                  <Grid item md={6} sm={12}>
                    {this.renderCriteriaSide('left')}
                  </Grid>
                  <Grid item md={6} sm={12}>
                    {this.renderCriteriaSide('right')}
                  </Grid>
                </Grid>
                <div className="spacer-2" />
              </Section>
              <Grid container spacing={16}>
                <SpecLeft item xs={12} md={8}>
                  <AddPhoto
                    photo={this.props.internalSlip.luminaireImage}
                    photo1={this.props.internalSlip.polarDiagramImage}
                    photo2={this.props.internalSlip.dimensionsImage}
                  />
                </SpecLeft>
                <Grid item xs={12} md={4}>
                  <NoteAndUrl
                    generalNotes={this.props.internalSlip.generalNotes}
                    //   note={values.slipNote}
                    //   url={values.url}
                    //   details={this.state.supplierContact}
                  />
                </Grid>
              </Grid>
              <div className="spacer-2" />
              <SpecificationSheetFooter
                container
                spacing={16}
                alignItems="stretch"
              >
                <ArupInfo item xs={12} md={4}>
                  <InfoTitle>Arup info:</InfoTitle>
                  <div>
                    <p>
                      <InfoLeft> Name: </InfoLeft>
                      <InfoRight>
                        {this.props.internalSlip.demandContact.fullName}
                      </InfoRight>
                    </p>
                    <p>
                      <InfoLeft>E-mail: </InfoLeft>
                      <InfoRight>
                        {this.props.internalSlip.demandContact.email}
                      </InfoRight>
                    </p>
                    <p>
                      <InfoLeft>Office Address: </InfoLeft>
                      <InfoRight>
                        {this.props.internalSlip.demandContact.address}
                      </InfoRight>
                    </p>
                    <p>
                      <InfoLeft>Work Phone: </InfoLeft>
                      <InfoRight>
                        {this.props.internalSlip.demandContact.mobile}
                      </InfoRight>
                    </p>
                    <p>
                      <InfoLeft>Work Role: </InfoLeft>
                      <InfoRight>
                        {this.props.internalSlip.demandContact.workRole}
                      </InfoRight>
                    </p>
                  </div>
                </ArupInfo>
                <CompanyInfo item xs={12} md={4}>
                  <InfoTitle>Company info:</InfoTitle>
                  <div>
                    <LogoWrapper>
                      <InfoLeftLogo>Company Name: </InfoLeftLogo>
                      <Logo
                        image={`${API_ROOT}/asset/${this.props.internalSlip.companyDetailsResponse.logoId}`}
                      />
                      <InfoRight>
                        {
                          this.props.internalSlip.companyDetailsResponse
                            .companyName
                        }
                      </InfoRight>
                    </LogoWrapper>
                    <p>
                      <InfoLeft>Company Address: </InfoLeft>
                      <InfoRight>
                        {this.props.internalSlip.companyDetailsResponse.address}
                      </InfoRight>
                    </p>
                    <p>
                      <InfoLeft>User: </InfoLeft>
                      <InfoRight>
                        {
                          this.props.internalSlip.companyDetailsResponse
                            .fullName
                        }
                      </InfoRight>
                    </p>
                    <p>
                      <InfoLeft>E-mail: </InfoLeft>
                      <InfoRight>
                        {this.props.internalSlip.companyDetailsResponse.email}
                      </InfoRight>
                    </p>
                    <p>
                      <InfoLeft>Work Phone: </InfoLeft>
                      <InfoRight>
                        {this.props.internalSlip.companyDetailsResponse.phone}
                      </InfoRight>
                    </p>
                  </div>
                </CompanyInfo>
                <CompanyInfo item xs={12} md={2}>
                  <InfoTitle>Project info:</InfoTitle>
                  <div>
                    <p>
                      <InfoLeft>Project Location: </InfoLeft>
                      <InfoRight>
                        {this.props.internalSlip.projectDetails.location}
                      </InfoRight>
                    </p>
                    <p>
                      <InfoLeft>Project Business Area: </InfoLeft>
                      <InfoRight>
                        {
                          this.props.internalSlip.projectDetails
                            .projectUsageArea
                        }
                      </InfoRight>
                    </p>
                    <p>
                      <InfoLeft>Project type: </InfoLeft>
                      <InfoRight>
                        {
                          this.props.internalSlip.projectDetails
                            .projectUsageType
                        }
                      </InfoRight>
                    </p>
                    <p>
                      <InfoLeft>Project description: </InfoLeft>
                      <InfoRight>
                        {this.props.internalSlip.projectDetails.description}
                      </InfoRight>
                    </p>
                    <p>
                      <InfoLeft>Project confidential: </InfoLeft>
                      <InfoRight>
                        {this.props.internalSlip.projectDetails.confidential
                          ? 'Yes'
                          : 'No'}
                      </InfoRight>
                    </p>
                  </div>
                </CompanyInfo>
                <FooterSheetRight item xs={12} md={2}>
                  <b>Type:</b>
                  <H1NoMargin>
                    {this.props.internalSlip.ticketReferenceName}
                  </H1NoMargin>
                </FooterSheetRight>
              </SpecificationSheetFooter>
              <div className="spacer-2" />
              <DownloadButton
                variant="contained"
                color="primary"
                className="t-weight-b criteria-button "
                onClick={this.downloadSpecSheet}
              >
                Download Specification Sheet
              </DownloadButton>
              <div className="spacer-2" />
              {/* <SupplyNote note={this.props.internalSlip.slipNote} fullwidth />
              <div className="spacer-2" /> */}
              <Url url={this.props.internalSlip.internalFilesResponse.url} />
              <div className="spacer-2" />
              <SpecificationSheets
                files={this.getSpecificationSheets(
                  this.props.internalSlip.internalFilesResponse
                )}
              />
              <IesFile
                ies={this.props.internalSlip.internalFilesResponse.ies}
              />
              <Quotation
                ies={this.props.internalSlip.internalFilesResponse.quotation}
              />
              <Grid item md={12} className={'border-bottom-light-gray-2'}>
                <SupplyPhoto
                  photos={this.getSupplyPhotos(this.props.internalSlip)}
                  user={this.props.currentUser}
                />
              </Grid>
            </MainContainer>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

InternalSlipsInfoModal.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = store => {
  return {
    currentUser: store.user.user,
  };
};

export default withStyles(styles)(
  connect(mapStateToProps)(InternalSlipsInfoModal)
);
